import React from 'react';
import PropTypes from 'prop-types';
import './ButtonGroup.scss';

const ButtonGroup = ({ additionalClass, children }) => (
  <div className={`button-group ${additionalClass}`}>{children}</div>
);

ButtonGroup.defaultProps = {
  additionalClass: '',
};

ButtonGroup.propTypes = {
  additionalClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default ButtonGroup;
